import css from "styled-jsx/css";

export default css`
.searcher-box {
    .searcher-input{
        caret-color: #019df4;
        // font-family: var(--color-gp--white);
        background: var(--color-gp--white);
        border: 1px solid #d3d4d3;
        border-radius: 4px;
        width: 100%;
        color: #000;
        outline: none;
        vertical-align: super;
        padding-left: 40px;
        padding-right: 28px;
        padding-top: 12px;
        padding-bottom: 12px;
        -webkit-appearance: none;
    }
    .search-icon-container {
        min-width:22px;
        position: absolute;
        top: 11px;
        padding-left: 2px;
        left: 9px;
        z-index: 2;
        background-color: white;
    }
    .close-icon-container {
        cursor: pointer;
        width: 22px;
        height: 22px;
        position: absolute;
        top: 15px;
        right: 6px;
    }
}
`;
